import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/languex-app/src/components/screen/global-components/logo/Logo-trust.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/languex-app/src/components/screen/global-components/terms/TermsContent.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/privacy/components/PrivacyHero/PrivacyHero.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/privacy/components/PrivacySupport/PrivacySupport.tsx");
